module.exports = __webpack_public_path__ + "static/media/universe_cluster.6e114476.jpg";